import React from "react";
import FeedbackSection from "../components/FeedbackSection";
import { useTrial } from "../contexts/TrialContext";

/**
 * Standalone feedback popup opened from the user menu. Shows the same star
 * rating + note UI as the trial popup and shares the same account-wide status,
 * so feedback given here reflects in the trial popup and vice-versa.
 */
export default function FeedbackModal({ open, onClose }) {
  const trial = useTrial();
  if (!open) return null;

  const submitted = trial?.submitted || {
    feedback: false,
    extension: false,
    rating: null,
  };

  return (
    <div className="wrapper__feedback__model" onClick={onClose} >
      <div onClick={(e) => e.stopPropagation()} className="feedback__model__inner">
        <div className="wrapper__fb__head">
          <div className="heading">
            <h2 className="fb__16 fc__0E1218 fw__600 mb__10">Share Your Feedback</h2>
            <p className="fb__13 fc__5F636A">
              We'd love to hear your thoughts — your input helps us improve.
            </p>
          </div>
          <button className="common__btn close__btn" onClick={onClose} style={{ flexShrink: 0 }}>
            ✕
          </button>
        </div>
        <div className="wrapper__fb__content">
          <FeedbackSection
            heading={false}
            savedRating={submitted.rating}
            noteAlreadySubmitted={!!submitted.feedback}
            onNoteSubmitted={() => trial?.markSubmitted?.("feedback")}
            onRatingSaved={(v) => trial?.markRating?.(v)}
          />
        </div>
      </div>
    </div>
  );
}
